import { CLIENT_LOGOS } from "@/lib/site";

const Marquee = () => {
  const items = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section
      data-testid="clients-marquee"
      className="py-12 lg:py-16 border-y border-slate-200 bg-white overflow-hidden"
    >
      <div className="flex items-center gap-8 mb-8 px-5 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <span className="text-xs uppercase tracking-[0.22em] font-bold text-[#1f2a44]">
          Our Clients · Proud to be associated with
        </span>
        <span className="h-px flex-1 bg-slate-200" />
      </div>
      <div className="relative">
        <div className="flex items-center gap-12 lg:gap-16 fm-marquee whitespace-nowrap will-change-transform">
          {items.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              className="inline-flex h-20 lg:h-24 items-center justify-center shrink-0 px-2"
            >
              <img
                src={c.img}
                alt={c.name}
                className="h-full w-auto max-w-[180px] object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
